import type { HTMLAttributes, ReactNode } from "react";

export function GlassCard({
  children,
  className = "",
  ...rest
}: HTMLAttributes<HTMLDivElement> & {
  // Optional so GlassCard can double as a plain empty placeholder panel
  // (e.g. an empty detail-pane skeleton while data loads — see
  // src/components/ui/Skeleton.tsx usage in dashboard loading states).
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`glass ${className}`} {...rest}>
      {children}
    </div>
  );
}
